module.exports = __webpack_public_path__ + "static/AkkuratPro-BoldItalic-b7abd38f01e0b94143610f5eca546cc2.woff";